import React, {useRef } from "react";
import Button from "@material-ui/core/Button";
import OnlineBolt from "@material-ui/icons/OfflineBolt";
import IconButton from "@material-ui/core/IconButton";
import LingoliaScrapper from "./LingoliaScrapper"

const NewWordScrapper =(props)=> {

  const myref=useRef();


 const Scrap = () => {
 

  if(myref.current) {
    myref.current.scrape_component();
 }

//LingoliaScrapper(props.Language,props.handleScrap);
//  return;

    const cheerio = require("cheerio");
    const request = require("request");

    //alert(props.SearchedWord );
    //alert(props.Language );

    var return_list = [];
    var return_short = [];

    let url = "";
    if (props.Language == "Spanish") {
      url =
        "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/spanish-english/" +
        props.SearchedWord;
    } else if (props.Language == "German") {
      url =
        "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/german-english/" +
        props.SearchedWord;
    } else if (props.Language == "French") {
      url =
        "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/french-english/" +
        props.SearchedWord;
    }
    //else {url="https://context.reverso.net/translation/english-spanish/" + props.SearchedWord }
    else {
      url =
        "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/english-french/" +
        props.SearchedWord;
    }
    //alert(url);
    request(
      {
        method: "GET",
        url: url
      },
      (err, res, body) => {
        if (err) return console.error(err);
        let $ = cheerio.load(body);
        var count = 0;
        console.log($);
        $("#examples-content .text").each(function(i, e) {
          count++;
          //  alert($(this).text());
          var text = $(this).text();
          text = text.toString().trim();
          return_list.push(text);
        });

        $(".translation").each(function(i, e) {
          if (i > 5) {
            return;
          }
          if (i > 0) {
            var text = $(this).text();
            text = text.toString().trim();
            return_short.push(text);
          }
        });
        // return_list=[2,3];

        //return_list.push(5);

        //console.log(return_list);

        //props.ScrapperCall(Language2,PresentParticiple,PastParticiple,Present,Past,Past1,Conditional,Future,Imperativ,Imperativ1);
        // alert("in");
        props.handleScrap(return_list, props.Language, return_short, "contexo");
      }
    );
  };

    return (
      <div>
        <IconButton aria-label="Share" onClick={() => Scrap()}>
          <OnlineBolt />
        </IconButton>
      <LingoliaScrapper ref={myref} Language={props.Language} handleScrap={props.handleScrap} SearchedWord={props.SearchedWord}></LingoliaScrapper>
        {/* <Button id="New_Word_Scrap_Button" onClick={()=>this.Scrap()} variant="contained" color="secondary">
                        Sc
                        </Button> */}
      </div>
    );
}

export default NewWordScrapper;
